'use strict';
import {Dialog} from './dialog.js';
export class DialogMismatch extends Dialog {
	
	constructor(component_key) {
		super(component_key);
	}
	init() {
		super.init();
	}
	get track() {
		return ['view', 'stay', 'go'].reduce((accumulator, action) => {
			accumulator[action] = () => yalwa.basics.ga.event({
				category: 'mismatch_dialog',
				action,
				label: yalwa.v.user_ip_countryID
			});
			return accumulator;
		}, {});
	}
	load() {
		super.load()
		this.track.view();
		return this;
	}
	add_events() {
		super.add_events();
		this.$dialog.find(`.js-${this.component.component_type}_go`).off('click.track').on('click.track', this.track.go.bind(this));
		this.$dialog.find(`.js-${this.component.component_type}_stay`).off('click.track').on('click.track', this.track.stay.bind(this));
	}

}
